{
  "round_statistics": "Rundstatistik",
  "no_stats_tracked": "Ingen statistik registrerad för denna runda",
  "no_stats_available": "Ingen statistik tillgänglig",
  "fairway_accuracy": "Fairwayträffar",
  "total_fairways_attempted": "Totalt antal fairways",
  "fairway_hit_percentage": "Fairwayträff %",
  "center": "Mitten",
  "left": "Vänster",
  "right": "Höger",
  "short": "Kort",
  "long": "Lång",
  "green_accuracy": "Greenträffar",
  "total_greens_attempted": "Totalt antal greener",
  "greens_in_regulation": "Greener i regulation (GIR)",
  "gir_percentage": "GIR %",
  "on_green": "På green",
  "putting_performance": "Puttning",
  "total_putts": "Totalt antal puttar",
  "avg_per_hole": "Snitt per hål",
  "avg_per_gir": "Snitt per GIR",
  "first_putt_distribution": "Första puttens fördelning",
  "total_sinked": "Totalt sänkta puttar",
  "short_game": "Kortspel",
  "total_chips": "Totalt antal chippar",
  "up_and_downs": "Up and Downs",
  "up_and_down_percentage": "Up and Down %",
  "bunker_play": "Bunkerspel",
  "total_bunker_shots": "Totalt antal bunkerslag",
  "sand_saves": "Sand Saves",
  "sand_save_percentage": "Sand Save %",
  "penalties": "Pliktslag",
  "total_penalties": "Totalt antal pliktslag",
  "birdies": "Birdies",
  "three_putts": "3+ Puttar",
  "fairway": "Fairway",
  "gir_short": "GIR",
  "score_distribution": "Resultatfördelning",
  "eagle_or_better": "Eagle eller bättre",
  "birdie": "Birdie",
  "par": "Par",
  "bogey": "Bogey",
  "double_bogey_or_worse": "Dubbelbogey eller sämre",
  "total_scored_holes": "Totalt spelade hål",
  "dashboard": {
    "title": "Min statistik",
    "year": "År",
    "season": "Säsong {{year}}",
    "course": "Bana",
    "allYears": "Alla år",
    "allCourses": "Alla banor",
    "updating": "Uppdaterar...",
    "loadError": "Misslyckades att ladda statistik",
    "overview": {
      "title": "Översikt",
      "avgScore": "Snitt resultat",
      "fir": "FIR",
      "gir": "GIR",
      "avgPutts": "Snitt puttar"
    },
    "tabs": {
      "results": "Resultat",
      "accuracy": "FIR/GIR",
      "putting": "Puttar",
      "other": "Övrigt"
    },
    "accuracyStats": {
      "fairway": "Fairwayträffar",
      "fairwayLeft": "Vänster",
      "fairwayRight": "Höger",
      "gir": "Greenträffar",
      "greenLeft": "Vänster",
      "greenRight": "Höger",
      "greenShort": "Kort",
      "greenLong": "Lång"
    },
    "totalRounds": "Rundor",
    "totalHoles": "Hål",
    "avgScore": "Snitt",
    "avgToPar": "Snitt till par",
    "scoring": "Resultat",
    "accuracy": "Fairwayträffar",
    "putting": "Puttning",
    "other": "Övrig statistik",
    "metric": "Mätvärde",
    "you": "Du",
    "friends": "Vänner",
    "global": "Alla",
    "bestScore": "Bästa scratchresultat",
    "worstScore": "Sämsta resultat",
    "eagles": "Eagles",
    "birdies": "Birdies",
    "pars": "Parar",
    "bogeys": "Bogeys",
    "doubleBogeys": "Dubbelbogeys",
    "triplePlus": "+3 eller sämre",
    "fairwayHit": "Fairway %",
    "gir": "GIR %",
    "upAndDown": "Up & Down %",
    "sandSave": "Sand Save %",
    "avgPuttsPerHole": "Snitt puttar/hål",
    "avgPuttsPerRound": "Snitt puttar/runda",
    "totalPutts": "Totalt puttar",
    "totalChips": "Chippar",
    "totalBunkerShots": "Bunkerslag",
    "avgPenaltiesPerRound": "Snitt pliktslag/runda",
    "totalPenalties": "Totalt pliktslag",
    "fullRoundsOnly": "Endast fulla rundor",
    "scratchScoring": "Scratchresultat",
    "bestRound": "Bästa runda",
    "avgRound": "Rundsnitt",
    "best9Holes": "Bästa 9-hålsrunda",
    "avg9Holes": "9-hålsrundsnitt",
    "netScoring": "Nettoresultat",
    "rounds": "rundor",
    "holeStats": "Hålresultat",
    "avgChipsPerRound": "Avg. chips/runda",
    "avgBunkerShotsPerRound": "Avg. bunkerslag/runda"
  },
  "sunk_putt_distribution": "Fördelning av sänkta puttar",
  "holes_count": "{{count}} hål",
  "one_putts": "1 Putt",
  "chip_proximity": "Chipprecision (1. putt)",
  "approach_proximity": "Inkomstprecision (1. putt)",
  "proximity_holed": "I hålet"
}
